// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_CLEAR_CART_COUNT,
} from './constants';

export function clearCartCount() {
  return {
    type: COMMON_CLEAR_CART_COUNT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_CLEAR_CART_COUNT:
      return {
        ...state,
        fetchGetShoppingCarTotal: 0,
        fetchGetShoppingCarSuccess: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/clearCartCount.js